import React from 'react';
import { SuggestionItem } from './components/SuggestionItem/SuggestionItem';
import style from './Suggestions.scss';

export const Suggestions = ({
    suggestions = [],
    onClick,
    amount,
    className = '',
    isSpaceBetween = suggestions.length % 4 === 0,
    isSuggestionHighlighted
}) => (
    <div className={style.holder}>
        <ul className={`${style.suggestions} ${className} ${isSpaceBetween ? style.spaceBetween : style.center}`}>
            {
                suggestions.map((suggestion, index) =>
                    <SuggestionItem
                        key={index}
                        onClick={onClick}
                        amount={amount}
                        suggestion={suggestion}
                        isSuggestionHighlighted={isSuggestionHighlighted}
                    />
                )
            }
        </ul>
    </div>);
